const translations = {
  noPosts: "{name} has not posted anything yet.",
  notFound: "Community member not found.",
  postsBy: "Posts by {name}",
  sendMessage: "Send message",
  title: "Community Member Page"
};

export default translations;
